import { useState, useEffect } from 'react';
import { useAuth } from "../AuthContext";
import { useNavigate } from 'react-router-dom';
import API from '../api';

const Admin_Login = () => {
  const [values, setValues] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const { login, user } = useAuth(); // get `user`
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await API.post('/login', values, { withCredentials: true });
      login(res.data.user);
      setMessage(res.data.message);

        
    if (res.data.user.email === 'smmanik0075@gmail.com') {
      navigate('/admin_dashboard');
    }

    } catch (err) {
      console.error(err);
      setMessage('Invalid email or password');
    }
  };

// ✅ Redirect only if email matches the admin email
  useEffect(() => {
    if (user?.email === 'smmanik0075@gmail.com') {
      navigate('/admin_dashboard');
    }
  }, [user, navigate]);


  // 🔁 Wait for user state to update before redirecting
  useEffect(() => {
  }, [user, navigate]);

  return (
    <section id="hero-area" className="header-area header-ten">
      <div className="header-inner">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 co-12">
              <div className="home-slider">
                <div className="form-container">
                  <h1>Login</h1>
                  <form onSubmit={handleSubmit}>
                    <div>
                      <label htmlFor='email'>Email</label>
                      <input type='email' name='email' required onChange={handleChange} />
                    </div>
                    <div>
                      <label htmlFor='password'>Password</label>
                      <input type='password' name='password' required onChange={handleChange} />
                    </div>
                    <div>
                      <button type='submit'>Login</button>
                    </div>
                  </form>

                  {message && <p>{message}</p>}

                  <div className="form-footer">
                    Don't have an account? <a href="/signup">Sign Up Here</a>
                  </div>
                  <div className="form-footer">
                    <a href="/forgot_password">Forgot Password?</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Admin_Login;
